"use strict";
// All the learning stage and difficulty level related constants
Object.defineProperty(exports, "__esModule", { value: true });
exports.UPLOAD_LESSON_EXTENSIONS = exports.sectionLabel = exports.normalizeSection = exports.SECTION_DISPLAY_TITLES = exports.SECTION_SHORT_HEADERS = exports.SECTIONS = exports.difficultyToCssClass = exports.ASSIGNED_DIFFICULTIES = void 0;
var ASSIGNED_DIFFICULTIES;
(function (ASSIGNED_DIFFICULTIES) {
    ASSIGNED_DIFFICULTIES["EMERGING"] = "Emerging";
    ASSIGNED_DIFFICULTIES["INTERMEDIATE"] = "Intermediate";
    ASSIGNED_DIFFICULTIES["ADVANCED"] = "Advanced";
})(ASSIGNED_DIFFICULTIES || (exports.ASSIGNED_DIFFICULTIES = ASSIGNED_DIFFICULTIES = {}));
exports.difficultyToCssClass = {
    [ASSIGNED_DIFFICULTIES.EMERGING]: 'emerging',
    [ASSIGNED_DIFFICULTIES.INTERMEDIATE]: 'intermediate',
    [ASSIGNED_DIFFICULTIES.ADVANCED]: 'advanced',
    'Not assigned': 'notAssigned'
};
// This is defined in the Eduquery API
var SECTIONS;
(function (SECTIONS) {
    SECTIONS["PRE_ASSESSMENT"] = "pre_assessment";
    SECTIONS["POST_ASSESSMENT"] = "post_assessment";
    SECTIONS["CHECK_FOR_UNDERSTANDING"] = "check_for_understanding";
    SECTIONS["INDEPENDENT_WORK"] = "independent_work";
})(SECTIONS || (exports.SECTIONS = SECTIONS = {}));
// This is used in the lesson overview table
exports.SECTION_SHORT_HEADERS = {
    [SECTIONS.PRE_ASSESSMENT]: 'PreAQs',
    [SECTIONS.CHECK_FOR_UNDERSTANDING]: 'Check Qs',
    [SECTIONS.INDEPENDENT_WORK]: 'Indep. Qs',
    [SECTIONS.POST_ASSESSMENT]: 'PostAQs',
};
// What users see for each section: slide headers, presentation/live views,
// results pages. Render through sectionLabel(), never the raw key.
exports.SECTION_DISPLAY_TITLES = {
    [SECTIONS.PRE_ASSESSMENT]: 'Pre-Assessment',
    [SECTIONS.CHECK_FOR_UNDERSTANDING]: 'Check for Understanding',
    [SECTIONS.INDEPENDENT_WORK]: 'Independent Work',
    [SECTIONS.POST_ASSESSMENT]: 'Post-Assessment',
};
// TODO:Rename/standardize later
const normalizeSection = (stage) => {
    switch (stage) {
        case 'Pre-Assessment': return SECTIONS.PRE_ASSESSMENT;
        case 'Post-Assessment': return SECTIONS.POST_ASSESSMENT;
        case 'Check for Understanding': return SECTIONS.CHECK_FOR_UNDERSTANDING;
        case 'Independent Work': return SECTIONS.INDEPENDENT_WORK;
        // Older label for check-for-understanding still present in stored results
        case 'Stop & Check': return SECTIONS.CHECK_FOR_UNDERSTANDING;
        default: return stage;
    }
};
exports.normalizeSection = normalizeSection;
// Title Case for a machine key we have no label for: 'some_new_stage' -> 'Some New Stage'
const titleCaseKey = (key) => key
    .replace(/[_-]+/g, ' ')
    .trim()
    .split(/\s+/)
    .map(w => (w ? w[0].toUpperCase() + w.slice(1).toLowerCase() : w))
    .join(' ');
/**
 * A section/learning stage as a proper display title, whichever form it
 * arrives in: the enum key ('independent_work'), the stored display string
 * ('Independent Work'), or the older 'Stop & Check'. Unknown values are
 * Title Cased rather than shown as raw keys.
 */
const sectionLabel = (stage) => {
    if (!stage)
        return '';
    const section = (0, exports.normalizeSection)(stage);
    return exports.SECTION_DISPLAY_TITLES[section] ?? titleCaseKey(stage);
};
exports.sectionLabel = sectionLabel;
/**
 * Single source of truth for which file extensions the lesson-upload
 * endpoint accepts (`POST /lessons`). Previously duplicated independently
 * on each side -- the frontend's picker (`web/src/pages/upload-lessons.tsx`)
 * only allowed `.pdf/.ppt/.pptx` while the backend
 * (`api/src/services/lesson-upload.ts`) also accepted
 * `.doc/.docx/.odp/.odt/.key` for the same endpoint, silently blocking a
 * teacher's legitimate Keynote/OpenOffice file before it ever reached a
 * server that would have accepted it. Found in the 2026-09-30 full-tree
 * Lego audit (`docs/AUDIT-2026-09-30-fulltree-util-shared.md`, finding #1).
 */
exports.UPLOAD_LESSON_EXTENSIONS = ['.pdf', '.ppt', '.pptx', '.doc', '.docx', '.odp', '.odt', '.key'];
